import { useTranslation } from 'react-i18next';

export function LoggedOutPage() {
  const { t } = useTranslation();
  return (
    <div
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}
    >
      <p style={{ fontSize: 16, margin: 0 }}>{t('auth.loggedOut.message')}</p>
    </div>
  );
}
